export const TEXTS = {
    CANCEL: "Cancel",
    RECENT_SEARCHES: "Recent Searches",
    CLEAR: "Clear",
    OOPS: "Something went wrong!!!",
    NO_RESULTS_FOUND: "No Results for ",
};

export const SEARCHES_KEY = "RECENT_SEARCHES";
export const SEARCHES_KEY_V2 = "RECENT_SEARCHES_V2";
export const MAX_RECENT_SEARCHES = 5;

export const CLEAR_IMAGE_URL = "/pub/static/frontend/Nykaa/theme001/en_US/images/clear.png";
export const CLEAR_IMAGE_WIDTH = 20;
export const SEARCH_URL = "/catalogsearch/result/";

export enum SEARCH_TERM_TYPE {
    SEARCH = "SEARCH",
    PRODUCT = "PRODUCT",
}

export const SEARCH_TYPE = {
    MANUAL: "Manual",
    AUTO_COMPLETE: "Autocomplete",
    RECENT_SEARCH: "SearchedFromHistory",
};
